export enum CourierTypeReportActionTypes {
    GET_COURIER_TYPE_REPORT_LIST = "GET_COURIER_TYPE_REPORT_LIST",
    GET_COURIER_TYPE_REPORT_LIST_SUCCESS = "GET_COURIER_TYPE_REPORT_LIST_SUCCESS",
    GET_COURIER_TYPE_REPORT_LIST_FAIL = "GET_COURIER_TYPE_REPORT_LIST_FAIL",
}
